import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VaveRoutingModule } from './vave-routing.module';
import { VaveComponent } from './vave.component';
import { RequestComponent } from './request/request.component';
import { NewComponent } from './request/new/new.component';
import { ListComponent } from './request/list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, BrowserXhr } from '@angular/http';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { SupportComponent } from './request/support/support.component';


@NgModule({
  imports: [
    CommonModule,
    VaveRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule,
    TooltipModule.forRoot(),
    NgMultiSelectDropDownModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
   
  ],
  declarations: [
    VaveComponent,
    RequestComponent,
    NewComponent,
    ListComponent,
    SupportComponent
  ]
})
export class VaveModule { }
